import React, { useState, useCallback } from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/contactus_background.jpg";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import { set } from "date-fns";
import { faL } from "@fortawesome/free-solid-svg-icons";

const CareerPage = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isNameValid, setIsNameValid] = useState(false);
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const handleFileChange = (e) => {
    // We only want the first file if multiple are selected
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleInputChange = (e, setValue, label) => {
    setValue(e.target.value);
  };

  const sendTheResume = async () => {
    setIsLoading(true);
    const regexMap = {
      name: /^[A-Za-z\s]{5,}$/, // For names: allow only alphabets and spaces
      address: /^[A-Za-z0-9\s]*$/,
      postalCode: /^[A-Za-z0-9\s]*$/, // For Canadian postal code
      email: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      phone: /^(\+?1[ .-]?)?\(?\d{3}\)?[ .-]?\d{3}[ .-]?\d{4}$/,
    };
    if (
      !regexMap["name"].test(fullName) ||
      !regexMap["email"].test(email) ||
      !regexMap["phone"].test(phone)
    ) {
      alert("Please fill all required fields with correct format.");
      setIsLoading(false);
      return;
    }
    if (file === null) {
      alert("Please upload your resume/CV");
      setIsLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append("pdfFile", file);
    formData.append("name", fullName);
    formData.append("email", email);
    formData.append("phone", phone);
    await axiosReqConfig(`${API_IP}/api/career-resume`, "POST", formData);
    setIsCompleted(true);
  };

  const reasons = [
    "Meaningful work supporting seniors in their homes",
    "Flexible scheduling with local clients",
    "Competitive hourly wages",
    "Supportive team and clear care standards",
    "Opportunity to grow in community-based care",
  ];

  const scrollToElement = () => {
    const element = document.getElementById("apply-now-section");
    if (element) {
      const elementPosition = element.offsetTop;
      window.scrollTo({
        top: elementPosition,
        behavior: "smooth", // Optional: smooth scrolling
      });
    }
  };
  return (
    <>
      <div className="CareerContainer">
        <div className="CareerTopContainer">
          <h2>A Career with Purpose and Heart</h2>
          <p>📍 Victoria, British Columbia, Canada </p>
          <p>
            Per-hour: $23 - $28 (Depending on role, experience, and training)
          </p>
          <p>Ready to make a meaningful difference in someone’s life?</p>
          <p>
            iCare Village is a home care service provider dedicated to
            supporting seniors to live safely and independently at home. We are
            growing our care team and are looking for compassionate care aides,
            nursing students, and experienced care professionals who want
            flexible, rewarding work with purpose.
          </p>
          <div className="CareerTopButtonContainer">
            <button className="CareerTopApplyButton" onClick={scrollToElement}>
              Apply Now
            </button>
            {/* <button className="CareerTopCallButton">Call Us</button> */}
          </div>
        </div>
        <div className="CareerApplyBoxContainer">
          <div id="apply-now-section" className="CareerFormContainer">
            <h1>Apply Now</h1>
            {!isCompleted ? (
              <>
                <p className="CareerRequiredFields">
                  Fields marked with * are required
                </p>

                <div className="CareerFormGroup">
                  <label htmlFor="CareerFullName">Your Full Name *</label>
                  <input
                    type="text"
                    id="CareerFullName"
                    name="CareerFullName"
                    value={fullName}
                    placeholder="e.g., Jane Smith"
                    onChange={(e) => handleInputChange(e, setFullName, "name")}
                    required
                  />
                </div>

                <div className="CareerFormGroup">
                  <label htmlFor="CareerEmail">Email *</label>
                  <input
                    type="email"
                    id="CareerEmail"
                    name="CareerEmail"
                    value={email}
                    placeholder="e.g., janesmith@email.com"
                    onChange={(e) => handleInputChange(e, setEmail, "email")}
                    required
                  />
                </div>

                <div className="CareerFormGroup">
                  <label htmlFor="CareerPhone">Your Phone *</label>
                  <input
                    type="tel"
                    id="CareerPhone"
                    name="CareerPhone"
                    value={phone}
                    placeholder="e.g., 250-123-4567"
                    onChange={(e) => handleInputChange(e, setPhone, "phone")}
                    required
                  />
                </div>
                <div className="CareerFormGroup">
                  <label htmlFor="CareerPhone">Resume/CV *</label>
                  <div>
                    <div
                      style={{
                        border: "2px dashed #ccc",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="file"
                        accept=".pdf"
                        onChange={handleFileChange}
                      />
                    </div>
                    <p className="ContactUSNoteText">
                      Please upload your resume outlining relevant care, health,
                      or support experience.
                    </p>
                  </div>
                  <div className="CareerFormGroup CareerCheckboxGroup">
                    <label className="CareerCheckboxTitle">
                      Why Join iCare Village? (Select all that apply)
                    </label>

                    {[
                      "Meaningful work supporting seniors in their homes",
                      "Flexible scheduling with local clients",
                      "Competitive hourly wages",
                      "Supportive team and clear care standards",
                      "Opportunity to grow in community-based care",
                    ].map((item, index) => (
                      <div key={index} className="CareerCheckboxItem">
                        <input
                          type="checkbox"
                          id={`reason-${index}`}
                          name="joinReason"
                          value={item}
                          className="CareerCheckboxInput"
                        />
                        <label
                          htmlFor={`reason-${index}`}
                          className="CareerCheckboxLabel"
                        >
                          {item}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <button
                  onClick={sendTheResume}
                  disabled={isLoading}
                  className="CareerSubmitButton"
                >
                  {isLoading ? "Loading..." : "Submit Application"}
                </button>
                <p className="ContactUSNoteText">
                  All applications are reviewed by our care leadership team.
                  Shortlisted candidates will be contacted for next steps,
                  including screening and onboarding requirements.
                </p>
              </>
            ) : (
              <div className="CareerCompleteContainer">
                <img
                  src={require(`../images/booking_accepted_icon.webp`)}
                  className="CareerCompleteIcon"
                />
                <h3>
                  You have successfully submitted your application. We will get
                  back to you soon.
                </h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerPage;
